import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import {featureInterface} from "../../../interfaces/featureInterface";
import {getFeatureOptions, getOptionStyles} from "../lookNavigation/lookFunctions";
import {capitalizeFirstLetters} from "../../../misc/helpers";


const ShopFeatureOptionsCommon = (props) => {

  const {feature, filterGroups, optionsButtonClick, withTitle, navItemOptions} = props;
  let {activeOption} = props;

  const [availableOptions, setAvailableOptions] = useState([]);

  useEffect(() => {
    const colorOptions = getFeatureOptions(feature, filterGroups, true, navItemOptions);
    // console.log("colorOptions", colorOptions);
    setAvailableOptions(colorOptions || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature.partId]);

  if (!availableOptions.length) {
    return null
  }

  if (withTitle && !activeOption) {
    activeOption = availableOptions.find(colorOption => colorOption.feature.dbFeature.id === feature.dbFeature.id)
  }

  const activeOptionText = withTitle && activeOption
    ? capitalizeFirstLetters((activeOption.colorValue.displayText || activeOption.colorValue.value).replace("GROHE ", ""))
    : null;

  return (
    <div className="lk-feature__options">
      {withTitle ? (
        <h3 className="shop-feature__sub-title">
          <FormattedMessage id="grohe.filter.color"/>:
          <span className="lk-feature__options-title-text">{activeOptionText}</span>
        </h3>
      ) : null}
      <ul className="lk-feature__options-list lk-feature__options-list--small">
        {availableOptions.map(option => {
          const isActive = activeOption && (option.colorValue.id === activeOption.colorValue.id);
          const styles = getOptionStyles(option.colorValue);
          return (
            <li className={"lk-color lk-color--" + option.colorValue.id +  (isActive ? " lk-color--active" : "")}
                key={option.colorValue.id}
                onClick={() => optionsButtonClick(option)}
                style={styles}/>
          )
        })}
      </ul>
    </div>
  )
};

ShopFeatureOptionsCommon.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired,
  activeOption: PropTypes.object,
  optionsButtonClick: PropTypes.func.isRequired,
  withTitle: PropTypes.bool,
  navItemOptions: PropTypes.arrayOf(PropTypes.shape(featureInterface)),
}

const mapStateToProps = (store) => {
  // const {isMobile} = store.serverState;
  const {filterGroups} = store.filterState;
  // const fabricatorData = store.fabricatorState;
  // const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    // isMobile,
    // fabricatorData,
    // isPhoneNumberValidated,
    filterGroups,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopFeatureOptionsCommon)
)
